import React from "react";
import config from "appConfig";

import { InputType } from "../../../models";
import { InputText } from "../InputText";
import { parseFormControlValue } from "../../../services";
import AveragePriceButton from "./AveragePriceButton";
import styles from "./money.scss";

const Money = props => {
  const {
    value,
    field,
    defaultValue,
    title,
    isRequired
  } = props;

  const handleValueChange = value => {
    const { field, onChange } = props;

    // InputText passes either an object { field: value } or empty string ""
    if (value === "" || value === undefined || value === null) {
      onChange({ [field]: undefined });
      return;
    }

    const fieldValue = typeof value === "object" ? value[field] : value;

    onChange(
      parseFormControlValue(
        [field],
        [fieldValue !== undefined ? fieldValue : ""]
      )
    );
  };

  return (
    <React.Fragment>
      <span className={`control-title ${isRequired ? "required" : ""}`}>
        {title}
      </span>
      <div className={field === "price" ? styles.priceWrapper : undefined}>
        <div className={field === "price" ? styles.priceInput : undefined}>
          <InputText
            unit={config.currencySymbol}
            valueType={InputType.float}
            field={field}
            value={value}
            defaultValue={defaultValue == 0 ? "" : defaultValue}
            onChange={handleValueChange}
            inputTypeNumber={true}
          />
        </div>
        {field === "price" && <AveragePriceButton />}
      </div>
    </React.Fragment>
  );
};

Money.defaultProps = {
  title: "",
  isRequired: false,
  defaultValue: 0,
  onChange: () => null
};

export default Money;



// WEBPACK FOOTER //
// ./src/components/FormControls/Money/Money.tsx